import VueApollo from '../../../../../../../app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '../../../../../../../app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '../../../../../../../app/assets/javascripts/lib/graphql.js?vue3';
import ComplianceInfo from './components/compliance_info.vue?vue3';

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export function initComplianceInfo() {
  const el = document.getElementById('js-compliance-info');

  if (!el) {
    return null;
  }

  const { projectPath, complianceCenterPath, canViewDashboard } = el.dataset;

  return initVueApp({
    el,
    name: 'ComplianceInfoRoot',
    apolloProvider,
    component: ComplianceInfo,
    props: {
      projectPath,
      complianceCenterPath,
      canViewDashboard,
    },
  });
}
